import { serviceName as restorationServiceName, jobResourceType, } from '@eigtech/restoration-types';
import { getCornKernels, isCorn } from '@eigtech/shared-corn';
export const ensureJobCorn = (jobId) => isCorn(jobId) ? jobId : makeJobCorn(jobId);
export const makeJobCorn = (resourceId) => `corn:${restorationServiceName}:${jobResourceType}:${resourceId}`;
export const isJobCorn = (entityId) => {
    if (!isCorn(entityId))
        return false;
    const { serviceName, resourceType } = getCornKernels(entityId);
    return serviceName === restorationServiceName && resourceType === jobResourceType;
};
export const ensureJobId = (entityId) => getCornKernels(ensureJobCorn(entityId)).resourceId;
